import ResourceService from "./resource.service";

class MobileDeviceService extends ResourceService {
  static get resource() {
    return "mobile-device";
  }
}

export default MobileDeviceService;
